import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-shimmer-loading",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./shimmer-loading.component.html",
  styleUrl: "./shimmer-loading.component.scss",
})
export class ShimmerLoadingComponent {
  @Input() shimmerFor: string = "";
  @Input() loaderHeight: string = '100px';
  @Input() loaderWidth: string = '100px';
  @Input() loaderMaxWidth: string = 'none';
  @Input() rounded: boolean = false;

  constructor() {}
}
